<template lang="pug">
Component(
    :is="modalState.component"
    class="tl-prime-dialog"
    v-bind="modalState.bindings"
    v-on="modalState.listeners || {}"
)

</template>

<script lang="ts" setup>
import useModal from '@/composables/modal'

const { modalState } = useModal()
</script>